import { render, staticRenderFns } from "./carCard.vue?vue&type=template&id=629f21a5&"
import script from "./carCard.vue?vue&type=script&lang=js&"
export * from "./carCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports